import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const QRCodeIcon: FC<{
	className?: string
	width?: number
	height?: number
	fill?: string
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M2.82 8.5C3.36 8.5 3.64 8.19 3.64 7.66V5.25C3.64 4.19 4.21 3.65 5.23 3.65H7.7C8.24 3.65 8.54 3.35 8.54 2.82C8.54 2.29 8.24 2 7.7 2H5.21C3.07 2 2 3.05 2 5.16V7.66C2 8.19 2.3 8.5 2.82 8.5ZM21.17 8.5C21.71 8.5 22 8.19 22 7.66V5.16C22 3.05 20.93 2 18.79 2H16.29C15.76 2 15.46 2.29 15.46 2.82C15.46 3.35 15.76 3.65 16.29 3.65H18.76C19.77 3.65 20.36 4.19 20.36 5.25V7.66C20.36 8.19 20.65 8.5 21.17 8.5ZM7.55 11.56H11.1C11.36 11.56 11.55 11.36 11.55 11.12V7.55C11.55 7.3 11.36 7.1 11.1 7.1H7.55C7.29 7.1 7.1 7.3 7.1 7.55V11.12C7.1 11.36 7.29 11.56 7.55 11.56ZM12.88 11.56H16.43C16.69 11.56 16.88 11.36 16.88 11.12V7.55C16.88 7.3 16.69 7.1 16.43 7.1H12.88C12.62 7.1 12.43 7.3 12.43 7.55V11.12C12.43 11.36 12.62 11.56 12.88 11.56ZM7.99 10.67V7.99H10.66V10.67H7.99ZM13.32 10.67V7.99H15.99V10.67H13.32ZM8.76 9.89H9.89V8.77H8.76V9.89ZM14.1 9.89H15.22V8.77H14.1V9.89ZM7.55 16.9H11.1C11.36 16.9 11.55 16.71 11.55 16.45V12.89C11.55 12.64 11.36 12.44 11.1 12.44H7.55C7.29 12.44 7.1 12.64 7.1 12.89V16.45C7.1 16.71 7.29 16.9 7.55 16.9ZM12.56 13.68H13.68V12.57H12.56V13.68ZM15.64 13.68H16.75V12.57H15.64V13.68ZM7.99 16.01V13.33H10.66V16.01H7.99ZM8.76 15.22H9.89V14.11H8.76V15.22ZM14.09 15.22H15.22V14.11H14.09V15.22ZM5.21 22H7.7C8.24 22 8.54 21.7 8.54 21.18C8.54 20.65 8.24 20.35 7.7 20.35H5.23C4.21 20.35 3.64 19.81 3.64 18.75V16.34C3.64 15.8 3.35 15.5 2.82 15.5C2.29 15.5 2 15.8 2 16.34V18.83C2 20.95 3.07 22 5.21 22ZM16.29 22H18.79C20.93 22 22 20.94 22 18.83V16.34C22 15.8 21.7 15.5 21.17 15.5C20.64 15.5 20.36 15.8 20.36 16.34V18.75C20.36 19.81 19.77 20.35 18.76 20.35H16.29C15.76 20.35 15.46 20.65 15.46 21.18C15.46 21.7 15.76 22 16.29 22ZM12.56 16.77H13.68V15.65H12.56V16.77ZM15.64 16.77H16.75V15.65H15.64V16.77Z"
				fill={props.fill ? props.fill : 'white'}
			/>
		</svg>
	)
}

export default QRCodeIcon
